import { gql } from '@apollo/client';

export const FormFieldTypes = {
  TEXT: { key: 'TEXT', label: 'Text' },
  TEXTAREA: { key: 'TEXTAREA', label: 'Text Area' },
  NUMBER: { key: 'NUMBER', label: 'Number' },
  CURRENCY: { key: 'CURRENCY', label: 'Currency' },
  SELECT: { key: 'SELECT', label: 'Select' },
  MULTI_SELECT: { key: 'MULTI_SELECT', label: 'Multi Select' },
  CHECKBOX: { key: 'CHECKBOX', label: 'Checkbox' },
  DATE: { key: 'DATE', label: 'Date' },
  FILE_UPLOAD: { key: 'FILE_UPLOAD', label: 'File Upload' },
};

export const ScheduleFrequencies = {
  WEEKLY: { key: 'WEEKLY', label: 'Weekly' },
  MONTHLY: { key: 'MONTHLY', label: 'Monthly' },
  QUARTERLY: { key: 'QUARTERLY', label: 'Quarterly' },
};

export const reportScheduleTemplateDetailedAttributes = gql`
  {
    _id
    name
    description
    frequency
    formFields {
      fieldId
      fieldType
      label
      required
      options
      placeholder
      helpText
      order
    }
    isArchived
    isLocked
    lockReason
    createdBy
    updatedBy
    deletedBy
    createdAt
    updatedAt
    deletedAt
  }
`;

export const reportScheduleTemplateListAttributes = gql`
  {
    _id
    name
    description
    frequency
    formFields {
      fieldId
      fieldType
      label
      required
      options
      placeholder
      helpText
      order
    }
    isArchived
    isLocked
    lockReason
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
`;

export const allReportScheduleTemplatesQuery = gql`
  query AllReportScheduleTemplates(
    $first: Int
    $after: String
    $filters: ReportScheduleTemplateFilters
    $sortBy: [SortBy]
  ) {
    allReportScheduleTemplates(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${reportScheduleTemplateListAttributes}
      }
    }
  }
`;

export const extractAllReportScheduleTemplates = (data) =>
  data?.allReportScheduleTemplates;

export const reportScheduleTemplateQuery = gql`
  query ReportScheduleTemplate($_id: ID!) {
    reportScheduleTemplate(_id: $_id) ${reportScheduleTemplateDetailedAttributes}
  }
`;

export const extractReportScheduleTemplate = (data) =>
  data?.reportScheduleTemplate;

export const createReportScheduleTemplateMutation = gql`
  mutation CreateReportScheduleTemplate(
    $template: ReportScheduleTemplateCreateInput!
  ) {
    createReportScheduleTemplate(template: $template) {
      template ${reportScheduleTemplateDetailedAttributes}
    }
  }
`;

export const updateReportScheduleTemplateMutation = gql`
  mutation UpdateReportScheduleTemplate(
    $template: ReportScheduleTemplateUpdateInput!
  ) {
    updateReportScheduleTemplate(template: $template) {
      template ${reportScheduleTemplateDetailedAttributes}
    }
  }
`;

export const deleteReportScheduleTemplateMutation = gql`
  mutation DeleteReportScheduleTemplate($_id: ID!) {
    deleteReportScheduleTemplate(_id: $_id) {
      deletedId
    }
  }
`;

export const reportScheduleTemplateUpdatesSubscription = gql`
  subscription ReportScheduleTemplateUpdates {
    reportScheduleTemplateUpdates {
      crud
      id
      new ${reportScheduleTemplateDetailedAttributes}
    }
  }
`;
